/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 麻痺(症状)
 */
export type FindEmsContactParalysisSymptomsEnum =
  (typeof FindEmsContactParalysisSymptomsEnum)[keyof typeof FindEmsContactParalysisSymptomsEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FindEmsContactParalysisSymptomsEnum = {
  COMPLETE: 'COMPLETE',
  INCOMPLETE: 'INCOMPLETE',
  SENSORY: 'SENSORY',
  HYPESTHESIA: 'HYPESTHESIA',
  NUMBNESS: 'NUMBNESS',
  SEVERE_SPEECH_DISORDER: 'SEVERE_SPEECH_DISORDER',
  SPEECH: 'SPEECH',
} as const;
